import {
  REACT_APP_API_ORIGIN
} from './constants'
// var ES6Promise = require("es6-promise");
// ES6Promise.polyfill();

import { lang } from '../services/constants';
var axios = require("axios");

const http = axios.create({
  baseURL: REACT_APP_API_ORIGIN,
  headers: {
     'Content-Type': 'application/json',
     'Accept-Language': lang,
  }
});

export const formDataHttp = axios.create({
  baseURL: REACT_APP_API_ORIGIN,
  headers: {
    'Content-Type': 'application/json',
    'Content-Disposition' : 'multipart/form-data',
    'Accept-Language': lang,
  }
});
export default http;
